
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";
import FileConfig from "../FileConfig";
import { PossibleStates, translatedStates } from "../enums/PossibleStates";
import {
  BIconQuestionCircleFill,
  BIconUpload,
  BIconCheck2,
  BIconX,
  BIconXCircleFill,
  BIconEyeFill,
} from "bootstrap-vue";
import { VueFilePondComponent } from "vue-filepond";
import ValidationService from "@/services/ValidationService";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import CodTipoDocumento from "@/enums/CodTipoDocumento";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import { ValidacionCedulaItResp } from "@/models/ValidacionCedulaIt";
import { ValidacionActaNacimientoResp } from "@/models/ValidacionActaNacimiento";
import { AxiosResponse } from "axios";
import { reemplazarCaracteresEspeciales } from "@/utils/HelperFunctions";
import { sanitizeFileName } from "@/utils/SanitizeFileName";

@Component({
  components: {
    BIconQuestionCircleFill,
    BIconUpload,
    BIconCheck2,
    BIconX,
    BIconEyeFill,
    BIconXCircleFill,
  },
})
export default class DocsUpload extends Vue {
  @Prop() itemNumber: number;
  @Prop() documents: BenefactorDocument[];
  @Prop() benefactor: Benefactor;
  @Prop({ default: "" }) cedulaFallecido: string;

  public reemplazarCaracteresEspeciales = reemplazarCaracteresEspeciales;
  public storageSASToken: string = "";
  public tableDocuments: BenefactorDocument[] = [];
  public fileConfig: FileConfig = new FileConfig();
  public sobrevivenciaService: SobrevivenciaService =
    new SobrevivenciaService();

  public showFileRequiredError: boolean = false;
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileSizeError: boolean = false;
  public showServerError: boolean = false;
  public showServerValidationMessage: boolean = false;
  public validationService = new ValidationService();
  public states = translatedStates;
  public validacionesDocumentos = {
    [CodTipoDocumento.ActaNacimientoConyugeLegalizada]: (
      validacionActaNacimiento: any,
      actaNacimiento: any
    ) =>
      this.validationService.validateActaNacimiento(
        validacionActaNacimiento,
        actaNacimiento
      ),
    [CodTipoDocumento.ActaNacimientoHijo]: (
      validacionActaNacimiento: any,
      actaNacimiento: any
    ) =>
      this.validationService.validateActaNacimiento(
        validacionActaNacimiento,
        actaNacimiento
      ),
    [CodTipoDocumento.CedulaHijoMayorDeEdad]: (
      validacionCedula: any,
      cedulas: any
    ) =>
      this.validationService.validateCedulaAfiliadoSobrevivencia(
        validacionCedula,
        cedulas
      ),
    [CodTipoDocumento.CopiaCedulaAfiliadoFallecido]: (
      validacionCedula: any,
      cedulas: any
    ) =>
      this.validationService.validateCedulaAfiliadoSobrevivencia(
        validacionCedula,
        cedulas
      ),
    [CodTipoDocumento.CopiaCedulaBeneficiariosNoLegales]: (
      validacionCedula: any,
      cedulas: any
    ) =>
      this.validationService.validateCedulaAfiliadoSobrevivencia(
        validacionCedula,
        cedulas
      ),
    [CodTipoDocumento.CedulaReverso]: (validacionCedula: any, cedulas: any) =>
      this.validationService.validateCedulaReverso(validacionCedula, cedulas),
    [CodTipoDocumento.CedulaDelantera]: (validacionCedula: any, cedulas: any) =>
      this.validationService.validateCedulaAfiliadoSobrevivencia(
        validacionCedula,
        cedulas
      ),
    [CodTipoDocumento.OtrasActas]: (
      validacionActaNacimiento: any,
      actaNacimiento: any
    ) =>
      this.validationService.validateActaNacimiento(
        validacionActaNacimiento,
        actaNacimiento
      ),
  };

  public thStyle = {
    "background-color": "#ed8b2f",
    color: " #fff",
    "text-align": "center",
  };
  public fields = [
    {
      key: "descDocumento",
      label: "Documento",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "estado",
      label: "Estado",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "actions",
      label: "Acciones",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "observaciones",
      label: "Observaciones",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
  ];

  async mounted() {
    this.getStorageSasToken();
  }
  @Emit("documentsChanged")
  documentsChanged() {
    return this.documents;
  }

  @Watch("documents")
  public documentsWatch() {
    console.log("Table documents");
    console.table(this.documents);
    this.tableDocuments = [...this.documents];
    this.tableDocuments = this.tableDocuments.filter((document) => {
      if (document.codTipDocumento != CodTipoDocumento.ComprobanteDeCuenta) {
        return document;
      }
    });
  }

  public popoverData(data) {
    return {
      html: true,
      content: `<div style='text-align: justify; text-justify: inter-word;' class='d-flex flex-column docs_popover_container align-items-center sub_label justity-text'><p class='docs_popover_message'>${
        data.ayudaTexto ? data.ayudaTexto : ""
      }</p> ${
        data.ayudaUrl
          ? "<figure class='d-flex flex-column justify-content-center align-items-center'><img class='docs_popover_image'  src='" +
            data.ayudaUrl +
            this.storageSASToken +
            "' alt=''/><a class='docs_popover_link mt-2' href='" +
            data.ayudaUrl +
            this.storageSASToken +
            "'  target='_blank'>Descargar muestra <span>aquí<span/></a></figure>"
          : ""
      }
      ${
        data.ayudaUrl2
          ? " <a class='docs_popover_link mt-0' href='" +
            data.ayudaUrl2 +
            this.storageSASToken +
            "'  target='_blank'>Descargar muestra No. 2 <span>aquí<span/></a></figure>"
          : ""
      }</div>`,
    };
  }

  public openFileSelector(inputRefTag) {
    const pond: any = this.$refs[inputRefTag];
    pond.browse();
  }

  public async areFilesValid(
    document: BenefactorDocument,
    filesPaths: string[]
  ) {
    var validationError = undefined;
    ///OJO FECHA DE NACIMIENTO DEBE SER LA DEL AFILIADO benefactor.FechaNac
    // OJO el nombre afilicado debe ser el delq ue se esta enviando
    let cedulaAfiliadoCalculated: string = "";

    //Si el beneficiario tiene un tutor , se enviará la cédula del tutor.
    if (this.benefactor != null) {
      if (
        this.benefactor.cedResponsable != null &&
        this.benefactor.cedResponsable.length > 0
      ) {
        cedulaAfiliadoCalculated = this.benefactor.cedResponsable;
      } else {
        cedulaAfiliadoCalculated = this.benefactor.numIdBeneficiario;
      }
    } else {
      cedulaAfiliadoCalculated = this.cedulaFallecido;
    }

    const commonValidationFields = {
      cedulaAfiliado: cedulaAfiliadoCalculated,
      nombreAfiliado: this.benefactor
        ? `${this.benefactor.primerNombre} ${this.benefactor.segundoNombre} ${this.benefactor.primerApellido} ${this.benefactor.segundoApellido}`
        : "",
      fechaNacimientoAfiliado: new Date(),
      path: filesPaths[0],
      generalDoc: this.benefactor ? false : true,
    };

    if (this.validacionesDocumentos[document.codTipDocumento]) {
      const response: AxiosResponse<
        ServiceResponseEntity<
          ValidacionCedulaItResp & ValidacionActaNacimientoResp
        >
      > = await this.validacionesDocumentos[document.codTipDocumento](
        commonValidationFields,
        {
          acta: document.files,
          cedulaFrontal: [document.files[0]],
          cedulaTrasera: [document.files[0]],
        }
      );

      if (
        this.benefactor &&
        !(
          response.data.respCode == 200 &&
          response.data.entity?.nombreCoincide &&
          response.data.entity?.fechaNacimientoCoincide
        )
      ) {
        validationError = response.data.message;
      }

      if (
        this.benefactor &&
        response.data.entity?.hasOwnProperty("cedulaCoincide") &&
        !response.data.entity?.cedulaCoincide
      ) {
        validationError = response.data.message;
      }

      if (response.data.respCode != 200) {
        validationError = response.data.message;
      }
      console.log("validation error: ", response);
    }
    return validationError;
  }

  public removeFiles(docIndex: number) {
    let pond = this.$refs[`files-${docIndex}`] as VueFilePondComponent;
    pond.removeFiles();
    this.documents[docIndex].estado = PossibleStates.Pendiente;
    this.documents[docIndex].files = undefined;
    (this.$refs.table as any).refresh();
  }

  public removeFilesCargado(docIndex: number) {
    console.log(this.documents[docIndex]);
    this.documents[docIndex].link = null;
    (this.$refs.table as any).refresh();
  }

  public async onAddOrRemoveFile(docIndex: number): Promise<void> {
    let pond = this.$refs[`files-${docIndex}`] as VueFilePondComponent;
    const document = this.documents[docIndex];
    let documentFiles = document.files;
    const pondFiles = pond.getFiles();

  const sanitizedFiles = pondFiles.map((x) => {
      const file = x.file as File;
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });
    documentFiles = sanitizedFiles;    document.files = documentFiles;

    const table: any = this.$refs.table;

    if (document.files.length > 0) {
      let filteredName = this.reemplazarCaracteresEspeciales(
        document.files[0].name
      );
      document.files[0] = new File([document.files[0]], filteredName, {
        type: document.files[0].type,
      });

      document.files.forEach((x) => {
        console.log(x);
      });

      document.estRecepDoc = PossibleStates.Cargando;

      table.refresh();

      this.showFileRequiredError = true;

      console.log("Tipos documento:");

      const anyFileTypeInvalid: boolean = documentFiles.some(
        (x) =>
          !this.fileConfig.allowedFileTypes.includes(x.type) ||
          x.name.includes(".fif") ||
          x.name.includes(".jfif")
      );
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      const anyFileSizeInvalid: boolean = documentFiles.some(
        (x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit
      );

      if (anyFileTypeInvalid) {
        document.estRecepDoc = PossibleStates.Rechazado;
        document.observaciones =
          "El formato del documento no es válido. Los formatos admitidos son: .jpeg, .jpg, .png, .pdf.";
        pond.removeFiles();
        table.refresh();
        return;
      }
      if (anyFileSizeInvalid) {
        document.estRecepDoc = PossibleStates.Rechazado;
        document.observaciones =
          "El documento excede el tamaño máximo  de 5MB.";
        pond.removeFiles();
        table.refresh();
        return;
      }

      const response = await this.uploadFile(document);

      if (response.data.respCode !== 200) {
        document.estRecepDoc = PossibleStates.Pendiente;

        table.refresh();

        return;
      }

      const validationError = await this.areFilesValid(
        document,
        response.data.entity
      );
      // this.
      console.log(validationError);
      if (validationError) {
        document.estRecepDoc = PossibleStates.Rechazado;
        document.observaciones = validationError;
        pond.removeFiles();
      } else {
        //ojo , colocar current benefactos.cedula
        document.observaciones = null;
        await this.sobrevivenciaService.GuardarDocumentacion(
          "PortalBe",
          "0092873730",
          document.files.map((file, index) => ({
            ...(this.benefactor
              ? { idBeneficiario: this.benefactor.idBeneficiario }
              : {}),
            link: response.data.entity[index],
            numPreSolicitud: document.numPreSolicitud,
            seqDocumento: document.seqDocumento,
          }))
        );
        document.estRecepDoc = PossibleStates.Cargado;
      }
    } else {
      if (!document.observaciones)
        document.estRecepDoc = PossibleStates.Pendiente;
    }

    table.refresh();

    this.documentsChanged();
  }

  public async uploadFile(document: BenefactorDocument) {
    const registroPresolicitud = new RegistroPresolicitud();
    registroPresolicitud.presolicitud.tipoBeneficio =
      TipoBeneficioEnum.Fallecimiento.toString();
    registroPresolicitud.presolicitud.numeroSolicitud =
      document.numPreSolicitud;
    registroPresolicitud.presolicitud.estado = "C";

    document.files.forEach((file) =>
      registroPresolicitud.tiposDocumento.push(file.type)
    );

    const files = { [document.codigoRuta]: document.files };

    const response = await this.callUpload(registroPresolicitud, files);

    return response;
  }

  public async callUpload(
    registroPresolicitud: RegistroPresolicitud,
    files: {
      [key: string]: File[];
    }
  ) {
    const response = await this.sobrevivenciaService.uploadDocumentation(
      registroPresolicitud,
      files
    );

    return response;
  }
  getObservacionesArray(value: string) {
    let array: string[];
    if (value != null && value.length > 0) {
      array = value.split("-");
    }
    return array;
  }

  get isGeneralDocument() {
    return this.benefactor ? false : true;
  }
  public async getStorageSasToken() {
    this.sobrevivenciaService.getStorageSAS().then((resp) => {
      this.storageSASToken = resp.data;
    });
  }
}
